export default __webpack_public_path__ + "static/media/logo_blue.5886e375.png";